import {
  Grid,
  Box,
  Typography,
  FormControl,
  FormGroup,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleConvertPxToPt } from "../helpers";

interface IProps {
  product: any;
  previewAgent: boolean;
  branding: any;
  technology: string;
  handleBtnPosition: (category: any) => void;
  ClickedCat: any;
  ClickedCatFbsVal: any;
}

const ThirdPagePreview = ({
  product,
  previewAgent,
  branding,
  ClickedCatFbsVal,
  ClickedCat,
  technology,
}: IProps) => {
  return (
    <Grid item xs={11} mt={previewAgent ? "35px" : "15px"}>
      <Grid item xs={12} mb={previewAgent ? "25px" : "15px"}>
        <label
          className="overflow-text-2-line"
          style={{
            margin: "15px 0 10px",
            color: branding?.[brandingConstants.inputLabelColor],
            fontSize: handleConvertPxToPt(
              branding?.[brandingConstants.inputLabelFontSize],
              previewAgent
            ),
            fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
            fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
            fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
          }}
        >
          {`Email ${product?.requireEmail ? "(required)" : ""}`}
        </label>
        <FormControl className="custom-select custom-textarea" fullWidth>
          <OutlinedInput
            className="noborder feedback-input"
            placeholder="Your email"
            type="text"
            sx={{
              color: branding?.[brandingConstants.inputFieldTextColor],
              // fontSize: handleFontPreview(
              //   branding?.[brandingConstants.inputLabelFontSize],
              //   previewAgent
              // ),
              fontSize: handleConvertPxToPt(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              background: branding?.[brandingConstants.inputFieldBGColor],
              border:
                "1px solid" +
                branding?.[brandingConstants?.inputFieldBorderColor],
              borderRadius:
                branding?.[brandingConstants.inputFieldBorderRadius],
              height: previewAgent ? "40px" : "30px",
              "&::placeholder": {
                fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
                fontFamily: previewAgent
                  ? branding?.[brandingConstants.inputLabelFontFamily]
                  : "11px",
                fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              },
              "& .MuiInputBase-input": {
                padding: "0!important",
                fontSize: `${handleConvertPxToPt(
                  branding?.[brandingConstants.inputLabelFontSize],
                  previewAgent
                )}!important`,
              },
            }}
          />
        </FormControl>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          maxHeight: "280px",
          overflow: "auto",
        }}
      >
        {ClickedCatFbsVal?.length > 0 && ClickedCat && (
          <Typography
            sx={{
              color: branding?.[brandingConstants.inputLabelColor],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontSize: handleConvertPxToPt(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
            }}
          >
            {ClickedCat && `${ClickedCat} :`}{" "}
            {product?.feedbackSettings?.stdFeedbackHeading}
          </Typography>
        )}
        <FormGroup
          className="tv-feedback-checkbox"
          sx={{
            marginTop: previewAgent ? "15px" : "10px",
            marginLeft: "2px",
          }}
        >
          {ClickedCatFbsVal?.length > 0 && ClickedCat && (
            <>
              {ClickedCatFbsVal.map((value: string) => {
                return (
                  // <FormControlLabel
                  //   control={
                  //     <Checkbox
                  //       icon={
                  //         <Box
                  //           display="flex"
                  //           justifyContent="center"
                  //           alignItems="center"
                  //         >
                  //           <CheckBoxOutlineBlankIcon
                  //             sx={{
                  //               width: previewAgent
                  //                 ? "20px!important"
                  //                 : "15px!important",
                  //               height: previewAgent
                  //                 ? "25px!important"
                  //                 : "15px!important",
                  //               color:
                  //                 branding?.[
                  //                   brandingConstants.inputFieldBorderColor
                  //                 ],
                  //             }}
                  //           />
                  //         </Box>
                  //       }
                  //       checkedIcon={
                  //         <Box
                  //           display="flex"
                  //           justifyContent="center"
                  //           alignItems="center"
                  //           sx={{
                  //             width: previewAgent
                  //               ? "20px!important"
                  //               : "15px!important",
                  //             height: previewAgent
                  //               ? "20px!important"
                  //               : "15px!important",
                  //             background:
                  //               branding?.[brandingConstants.inputFieldBGColor],
                  //             border: `1px solid ${
                  //               branding?.[
                  //                 brandingConstants.inputFieldBorderColor
                  //               ]
                  //             }`,
                  //           }}
                  //         >
                  //           <CheckIcon
                  //             sx={{
                  //               width: previewAgent
                  //                 ? "18px!important"
                  //                 : "10px!important",
                  //               height: previewAgent
                  //                 ? "18px!important"
                  //                 : "10px!important",
                  //               color:
                  //                 branding?.[
                  //                   brandingConstants.inputFieldBorderColor
                  //                 ],
                  //             }}
                  //           />
                  //         </Box>
                  //       }
                  //     />
                  //   }
                  //   sx={{
                  //     marginBottom: previewAgent ? "8px" : "10px",
                  //     "& .MuiTypography-root": {
                  //       fontSize: `${handleConvertPxToPt(
                  //         branding?.[brandingConstants.inputLabelFontSize],
                  //         previewAgent
                  //       )}!important`,
                  //       fontFamily: `${
                  //         branding?.[brandingConstants.inputLabelFontFamily]
                  //       }!important`,
                  //       fontWeight: `${
                  //         branding?.[brandingConstants.inputLabelFontWeight]
                  //       }!important`,
                  //       color: `${
                  //         branding?.[brandingConstants.inputLabelColor]
                  //       }!important`,
                  //     },
                  //   }}
                  //   label={value}
                  // />
                  <Box display="flex" alignItems="center">
                    <input
                      type="checkbox"
                      name={value}
                      value={value}
                      style={{
                        width: "20px",
                        height: "17px",
                        marginRight: "5px",
                      }}
                    />
                    <label
                      style={{
                        fontSize: handleConvertPxToPt(
                          branding?.[brandingConstants.inputLabelFontSize],
                          previewAgent
                        ),
                        fontFamily:
                          branding?.[brandingConstants.inputLabelFontFamily],
                        fontWeight:
                          branding?.[brandingConstants.inputLabelFontWeight],
                        color: branding?.[brandingConstants.inputLabelColor],
                      }}
                    >
                      {value}
                    </label>
                  </Box>
                );
              })}
            </>
          )}
        </FormGroup>
      </Grid>

      <Grid item xs={12}>
        <label
          className="overflow-text-2-line"
          style={{
            margin: "15px 0 10px",
            color: branding?.[brandingConstants.inputLabelColor],
            fontSize: handleConvertPxToPt(
              branding?.[brandingConstants.inputLabelFontSize],
              previewAgent
            ),
            fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
            fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
            fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
          }}
        >
          {`${product?.feedbackSettings?.generalCommentsHeading} ${
            product?.feedbackSettings?.reqComments ? "(required)" : ""
          }`}
        </label>
        <FormControl className="custom-select custom-textarea" fullWidth>
          <OutlinedInput
            className="noborder feedback-textarea"
            placeholder="Provide your comment"
            sx={{
              color: branding?.[brandingConstants.inputFieldTextColor],
              // fontSize: handleFontPreview(
              //   branding?.[brandingConstants.inputLabelFontSize],
              //   previewAgent
              // ),
              fontSize: `${handleConvertPxToPt(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              )}!important`,
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: previewAgent
                ? branding?.[brandingConstants.inputLabelFontFamily]
                : "11px",
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              background: branding?.[brandingConstants.inputFieldBGColor],
              border:
                "1px solid" +
                branding?.[brandingConstants?.inputFieldBorderColor],
              borderRadius:
                technology === "html5Tv"
                  ? branding?.[brandingConstants.inputFieldBorderRadius]
                  : "0px",
              height: previewAgent ? "150px" : "100px",
              "&::placeholder": {
                fontSize: handleConvertPxToPt(
                  branding?.[brandingConstants.inputLabelFontSize],
                  previewAgent
                ),
                fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
                fontFamily: previewAgent
                  ? branding?.[brandingConstants.inputLabelFontFamily]
                  : "11px",
                fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              },
              "& .MuiInputBase-input": {
                alignSelf: "start",
                padding: "0!important",
                fontSize: `${handleConvertPxToPt(
                  branding?.[brandingConstants.inputLabelFontSize],
                  previewAgent
                )}!important`,
              },
            }}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ThirdPagePreview;
